import { CodeTagsCheckIcon } from './CodeTagsCheckIcon';

/**
 * author: Simran
 * id 7F098441-8B1D-4FB1-88EC-95726397BA7C
 * name code-tags-check
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-tags-check.svg
 * tags
 * - Developer / Languages 
 */
export const CodeTagsTickIcon = CodeTagsCheckIcon;
export default CodeTagsTickIcon